import { render, staticRenderFns } from "./BannerEditorModal.vue?vue&type=template&id=4c027a20&scoped=true"
import script from "./BannerEditorModal.vue?vue&type=script&lang=js"
export * from "./BannerEditorModal.vue?vue&type=script&lang=js"
import style0 from "./BannerEditorModal.vue?vue&type=style&index=0&id=4c027a20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c027a20",
  null
  
)

export default component.exports